import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { getOnboardingCallLink } from '../../../self-upgrade.util';

export const CALL_INTEL_VIDEO_URL = 'https://fast.wistia.com/embed/medias/00q24rsmga';
export const CALL_INTEL_PRICE = 199;
export const CALL_INTEL_ENUM = Feature.CALL_INTELLIGENCE;
export const CALL_INTEL_ONBOARDING_URL = getOnboardingCallLink(Feature.CALL_INTELLIGENCE);
